import { c as _c } from "react/compiler-runtime";
import dynamic from "next/dynamic";
import { assertUnreachable } from "@/helpers/AllowlistToolHelpers";

// Import the media display components
import MediaDisplayImage from "./MediaDisplayImage";
import { ImageScale } from "@/helpers/image.helpers";
import MediaDisplayVideo from "./MediaDisplayVideo";
import MediaDisplayAudio from "./MediaDisplayAudio";
import SandboxedExternalIframe from "@/components/common/SandboxedExternalIframe";
enum MediaType {
  IMAGE = "IMAGE",
  VIDEO = "VIDEO",
  AUDIO = "AUDIO",
  GLB = "GLB",
  HTML = "HTML",
  UNKNOWN = "UNKNOWN",
}
const MediaDisplayGLB = dynamic(() => import("./MediaDisplayGLB"), {
  ssr: false
});

/**
 * A component to display media content without interactive modal functionality.
 * Identical to DropListItemContentMedia but without art viewing modal functionality.
 * Use this when you want to simply display media in a container that has its own click behavior.
 */
export default function MediaDisplay(t0) {
  const $ = _c(26);
  const {
    media_mime_type,
    media_url,
    disableMediaInteraction: t1,
    imageScale: t2
  } = t0;
  const disableMediaInteraction = t1 === undefined ? false : t1;
  const imageScale = t2 === undefined ? ImageScale.AUTOx600 : t2;
  let t3;
  if ($[0] !== media_mime_type || $[1] !== media_url) {
    t3 = () => {
      if (media_mime_type.includes("image")) {
        return MediaType.IMAGE;
      }
      if (media_mime_type.includes("video")) {
        return MediaType.VIDEO;
      }
      if (media_mime_type.includes("audio")) {
        return MediaType.AUDIO;
      }
      if (media_mime_type === "model/gltf-binary" || media_mime_type === "model/gltf+json" || media_url.endsWith(".glb") || media_url.endsWith(".gltf")) {
        return MediaType.GLB;
      }
      if (media_mime_type === "text/html") {
        return MediaType.HTML;
      }
      return MediaType.UNKNOWN;
    };
    $[0] = media_mime_type;
    $[1] = media_url;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const getMediaType = t3;
  let t4;
  if ($[3] !== disableMediaInteraction || $[4] !== getMediaType || $[5] !== imageScale || $[6] !== media_url) {
    t4 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const mediaType = getMediaType();
      switch (mediaType) {
        case MediaType.IMAGE:
          {
            let t5;
            if ($[8] !== imageScale || $[9] !== media_url) {
              t5 = <MediaDisplayImage src={media_url} imageScale={imageScale} />;
              $[8] = imageScale;
              $[9] = media_url;
              $[10] = t5;
            } else {
              t5 = $[10];
            }
            t4 = t5;
            break bb0;
          }
        case MediaType.VIDEO:
          {
            const t5 = !disableMediaInteraction;
            let t6;
            if ($[11] !== disableMediaInteraction || $[12] !== media_url || $[13] !== t5) {
              t6 = <MediaDisplayVideo src={media_url} showControls={t5} disableClickHandler={disableMediaInteraction} />;
              $[11] = disableMediaInteraction;
              $[12] = media_url;
              $[13] = t5;
              $[14] = t6;
            } else {
              t6 = $[14];
            }
            t4 = t6;
            break bb0;
          }
        case MediaType.AUDIO:
          {
            const t5 = !disableMediaInteraction;
            let t6;
            if ($[15] !== media_url || $[16] !== t5) {
              t6 = <MediaDisplayAudio src={media_url} showControls={t5} />;
              $[15] = media_url;
              $[16] = t5;
              $[17] = t6;
            } else {
              t6 = $[17];
            }
            t4 = t6;
            break bb0;
          }
        case MediaType.GLB:
          {
            let t5;
            if ($[18] !== disableMediaInteraction || $[19] !== media_url) {
              t5 = <MediaDisplayGLB src={media_url} disableMediaInteractions={disableMediaInteraction} />;
              $[18] = disableMediaInteraction;
              $[19] = media_url;
              $[20] = t5;
            } else {
              t5 = $[20];
            }
            t4 = t5;
            break bb0;
          }
        case MediaType.HTML:
          {
            let t5;
            if ($[21] !== media_url) {
              t5 = media_url.replace("ipfs://", "https://ipfs.io/ipfs/");
              $[21] = media_url;
              $[22] = t5;
            } else {
              t5 = $[22];
            }
            let t6;
            if ($[23] !== t5) {
              t6 = <SandboxedExternalIframe title="" src={t5} className="tw-w-full tw-h-full" />;
              $[23] = t5;
              $[24] = t6;
            } else {
              t6 = $[24];
            }
            t4 = t6;
            break bb0;
          }
        case MediaType.UNKNOWN:
          {
            let t5;
            if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
              t5 = <></>;
              $[25] = t5;
            } else {
              t5 = $[25];
            }
            t4 = t5;
            break bb0;
          }
        default:
          {
            assertUnreachable(mediaType);
          }
      }
    }
    $[3] = disableMediaInteraction;
    $[4] = getMediaType;
    $[5] = imageScale;
    $[6] = media_url;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  if (t4 !== Symbol.for("react.early_return_sentinel")) {
    return t4;
  }
}